const CorpType = {
  BANK: 'BANK',
  SAVING_BANK: 'SAVING_BANK',
  INSURANCE: 'INSURANCE',
  INVEST: 'INVEST',
  CAPITAL: 'CAPITAL',
  CARD: 'CARD',
  TELECOM: 'TELECOM',
  POINT: 'POINT'
};
const Prefixes = ['ORG', 'BK', 'IV', 'IS', 'CAPITAL', 'SB', 'CD', 'TEL', 'POINT'];

export { CorpType, Prefixes };
